import { Spin } from 'antd';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { HEADERMENU_PATH } from '../../../../../../routes/RoutesURL';
import { RootState } from '../../../../../../store/rootReducer';
import LoginActions from '../../../../../login/redux/actions';
import { SETTINGS_PATH } from '../../../../settings';
import { ONBOARDING_PATH } from '../../../Onbording';

const MyinfoRedirect: React.FC = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [searchParams] = useSearchParams();
    const error = searchParams.get('error');

    const myinfoPath = useSelector((state: RootState) => state.user.myinfoPath);
    const investorUUID = useSelector((state: RootState) => state.user.uuid);

    useEffect(() => {
        if (error || error === 'true') {
            if (myinfoPath && myinfoPath === 'onboarding') {
                navigate(`${HEADERMENU_PATH.onboarding}/${ONBOARDING_PATH.KYC}`, { state: { selectedType: 'error' } });
            } else {
                navigate(`${HEADERMENU_PATH.settings}/${SETTINGS_PATH.KYC}`, { state: { selectedType: 'error' } });
            }
        } else {
            if (myinfoPath && myinfoPath === 'onboarding') {
                navigate(`${HEADERMENU_PATH.onboarding}/${ONBOARDING_PATH.KYC}`, { state: { selectedType: 'Manual' } });
            } else {
                navigate(`${HEADERMENU_PATH.settings}/${SETTINGS_PATH.KYC}`, { state: { selectedType: 'Manual' } });
            }
        }
        if (investorUUID) {
            dispatch(LoginActions.fetchInvestor(investorUUID));
        }
    }, [error, myinfoPath, investorUUID, dispatch, navigate]);

    return (
        <div className="flex justify-center items-center h-screen flex-col">
            <Spin size="large" />
            <p className="text-lg font-semibold mt-4">Please wait</p>
        </div>
    );
};

export default MyinfoRedirect;
